module.exports = __webpack_public_path__ + "static/media/revertButton.1cbbbf62.svg";